<div class="iwb-notification-editor">
  <div class="iwb-inspector-tabs">
    <button
      type="button"
      class="iwb-itab"
      [class.on]="!jsonMode"
      (click)="setMode(false)">
      <i class="fa-solid fa-sliders"></i><span>Design</span>
    </button>
    <button
      type="button"
      class="iwb-itab"
      [class.on]="jsonMode"
      (click)="setMode(true)">
      <i class="fa-solid fa-code"></i><span>JSON</span>
    </button>
  </div>

  <ng-container *ngIf="!jsonMode; else jsonEditor">
    <div class="iwb-locale-issue" *ngIf="unsupportedLocales.length">
      <div class="iwb-locale-issue-copy">
        <b>Unsupported notification locale</b>
        <p>{{ localeError }}</p>
      </div>
      <div
        class="iwb-locale-issue-row"
        *ngFor="let locale of unsupportedLocales">
        <code>{{ locale }}</code>
        <select
          class="selx iwb-notification-select"
          [ngModel]="localePortTargets[locale]"
          (ngModelChange)="setLocalePortTarget(locale, $event)">
          <option *ngFor="let language of languages" [value]="language.locale">
            {{ language.name || language.locale }} · {{ language.locale }}
          </option>
        </select>
        <button
          type="button"
          class="btn"
          (click)="portUnsupportedLocale(locale)">
          Port content
        </button>
      </div>
    </div>

    <div
      class="iwb-locale-issue iwb-locale-issue--compact"
      *ngIf="missingNotificationLocaleLanguages().length">
      <div class="iwb-locale-issue-copy">
        <b>Missing notification translations</b>
        <p>
          Notification content is set for
          {{ configuredNotificationLocaleMessage() }} and missing for
          {{ missingNotificationLocaleMessage() }}. Recipients using the missing
          languages may receive fallback content or no localized notification.
          Please add the missing notification content or templates.
        </p>
      </div>
    </div>

    <div class="iwb-notification-grid">
      <section class="iwb-notification-pane">
        <div class="dfield">
          <label>Template source</label>
          <select
            class="selx iwb-notification-select"
            [ngModel]="model.notificationType"
            (ngModelChange)="setType($any($event))">
            <option value="NOTIFICATION_ENGINE_TEMPLATE">API template</option>
            <option value="STATIC">Static content</option>
          </select>
        </div>

        <div class="dfield">
          <label>Locale</label>
          <select
            class="selx iwb-notification-select"
            [ngModel]="selectedLocale"
            (ngModelChange)="selectLocale($event)">
            <option
              *ngFor="let language of languages"
              [value]="language.locale">
              {{ language.name || language.locale }} · {{ language.locale }}
            </option>
          </select>
        </div>

        <div class="dgrp">Channel</div>
        <div class="iwb-channel-tabs">
          <button
            type="button"
            [class.on]="selectedChannel === 'email'"
            (click)="setChannel('email')">
            <i class="fa-solid fa-envelope"></i><span>Email</span>
          </button>
          <button
            type="button"
            [class.on]="selectedChannel === 'sms'"
            (click)="setChannel('sms')">
            <i class="fa-solid fa-mobile-screen-button"></i><span>SMS</span>
          </button>
        </div>

        <ng-container
          *ngIf="
            model.notificationType === 'NOTIFICATION_ENGINE_TEMPLATE';
            else staticEditor
          ">
          <div class="iwb-template-create-bar" *ngIf="canCreateTemplates">
            <button type="button" class="btn" (click)="openCreateTemplate()">
              <i class="fa-solid fa-plus"></i>
              <span>Create template</span>
            </button>
          </div>

          <div class="dfield" *ngIf="selectedChannel === 'email'">
            <label>Email template</label>
            <div class="iwb-template-select-row">
              <ng-select
                class="iwb-template-select"
                [items]="emailTemplates"
                bindLabel="templateName"
                bindValue="templateName"
                [loading]="loadingTemplates"
                [clearable]="true"
                [searchable]="true"
                [ngModel]="draft().emailTemplateName"
                (ngModelChange)="setDraftValue('emailTemplateName', $event)"
                placeholder="Search and select email template">
                <ng-template ng-option-tmp let-item="item">
                  <span class="iwb-template-option">
                    <b>{{ item.templateName }}</b>
                    <small>{{ item.language || item.type }}</small>
                  </span>
                </ng-template>
              </ng-select>
              <button
                type="button"
                class="iwb-template-refresh"
                [disabled]="loadingTemplates"
                title="Refresh templates"
                aria-label="Refresh templates"
                (click)="refreshTemplates()">
                <i
                  class="fa-solid fa-rotate-right"
                  [class.fa-spin]="loadingTemplates"></i>
              </button>
            </div>
          </div>

          <div class="dfield" *ngIf="selectedChannel === 'sms'">
            <label>SMS template</label>
            <div class="iwb-template-select-row">
              <ng-select
                class="iwb-template-select"
                [items]="smsTemplates"
                bindLabel="templateName"
                bindValue="templateName"
                [loading]="loadingTemplates"
                [clearable]="true"
                [searchable]="true"
                [ngModel]="draft().smsTemplateName"
                (ngModelChange)="setDraftValue('smsTemplateName', $event)"
                placeholder="Search and select SMS template">
                <ng-template ng-option-tmp let-item="item">
                  <span class="iwb-template-option">
                    <b>{{ item.templateName }}</b>
                    <small>{{ item.language || item.type }}</small>
                  </span>
                </ng-template>
              </ng-select>
              <button
                type="button"
                class="iwb-template-refresh"
                [disabled]="loadingTemplates"
                title="Refresh templates"
                aria-label="Refresh templates"
                (click)="refreshTemplates()">
                <i
                  class="fa-solid fa-rotate-right"
                  [class.fa-spin]="loadingTemplates"></i>
              </button>
            </div>
          </div>

          <div
            class="iwb-template-create"
            *ngIf="canCreateTemplates && createTemplateVisible">
            <div class="iwb-template-create-head">
              <div>
                <b
                  >Create
                  {{ selectedChannel === 'email' ? 'email' : 'SMS' }}
                  template</b
                >
                <small
                  >Start from an existing template, edit the raw content, then
                  save it for selection.</small
                >
              </div>
              <button
                type="button"
                class="iwb-template-create-close"
                aria-label="Close create template"
                (click)="closeCreateTemplate()">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="dfield">
              <label>Template name</label>
              <input
                class="inp"
                [ngModel]="createTemplateDraft.templateName"
                (ngModelChange)="createTemplateDraft.templateName = $event"
                placeholder="Unique template name" />
            </div>

            <div class="dfield">
              <label>Language</label>
              <select
                class="selx iwb-notification-select"
                [ngModel]="createTemplateDraft.language"
                (ngModelChange)="createTemplateDraft.language = $event">
                <option
                  *ngFor="let language of languages"
                  [value]="language.locale">
                  {{ language.name || language.locale }} · {{ language.locale }}
                </option>
              </select>
            </div>

            <div class="dfield" *ngIf="selectedChannel === 'email'">
              <label>Source template</label>
              <ng-select
                class="iwb-template-select"
                [items]="emailTemplates"
                bindLabel="templateName"
                bindValue="templateName"
                [clearable]="true"
                [searchable]="true"
                [ngModel]="createTemplateDraft.sourceTemplateName"
                (ngModelChange)="selectCreateTemplateSource($event)"
                placeholder="Pick existing raw HTML">
                <ng-template ng-option-tmp let-item="item">
                  <span class="iwb-template-option">
                    <b>{{ item.templateName }}</b>
                    <small>{{ item.language || item.type }}</small>
                  </span>
                </ng-template>
              </ng-select>
            </div>

            <div class="dfield" *ngIf="selectedChannel === 'sms'">
              <label>Source template</label>
              <ng-select
                class="iwb-template-select"
                [items]="smsTemplates"
                bindLabel="templateName"
                bindValue="templateName"
                [clearable]="true"
                [searchable]="true"
                [ngModel]="createTemplateDraft.sourceTemplateName"
                (ngModelChange)="selectCreateTemplateSource($event)"
                placeholder="Pick existing SMS template">
                <ng-template ng-option-tmp let-item="item">
                  <span class="iwb-template-option">
                    <b>{{ item.templateName }}</b>
                    <small>{{ item.language || item.type }}</small>
                  </span>
                </ng-template>
              </ng-select>
            </div>

            <div class="dfield" *ngIf="selectedChannel === 'email'">
              <label>Email subject</label>
              <input
                class="inp"
                [ngModel]="createTemplateDraft.subject"
                (ngModelChange)="createTemplateDraft.subject = $event"
                placeholder="Subject shown to the recipient" />
            </div>

            <div class="dfield">
              <label>{{
                selectedChannel === 'email' ? 'Raw HTML' : 'SMS content'
              }}</label>
              <textarea
                class="inp iwb-notification-body"
                [class.iwb-notification-body--sms]="selectedChannel === 'sms'"
                [ngModel]="createTemplateDraft.content"
                (ngModelChange)="createTemplateDraft.content = $event"
                [placeholder]="
                  selectedChannel === 'email'
                    ? 'Paste or edit raw HTML'
                    : 'Paste or edit SMS text'
                "></textarea>
            </div>

            <div class="dnone" *ngIf="createTemplateError">
              {{ createTemplateError }}
            </div>
            <div class="iwb-template-success" *ngIf="createTemplateSuccess">
              {{ createTemplateSuccess }}
            </div>
            <div class="iwb-template-create-actions">
              <button
                type="button"
                class="btn"
                [disabled]="creatingTemplate"
                (click)="saveNewTemplate()">
                {{ creatingTemplate ? 'Saving...' : 'Save template' }}
              </button>
            </div>
          </div>

          <div class="iwb-template-success" *ngIf="createTemplateSuccess">
            {{ createTemplateSuccess }}
          </div>
          <div class="dnone" *ngIf="templateError">{{ templateError }}</div>
        </ng-container>

        <ng-template #staticEditor>
          <div class="dfield">
            <label>Start from template</label>
            <div class="iwb-template-select-row">
              <ng-select
                class="iwb-template-select"
                [items]="templatesForSelectedChannel()"
                bindLabel="templateName"
                bindValue="templateName"
                [loading]="loadingTemplates"
                [clearable]="true"
                [searchable]="true"
                [ngModel]="staticTemplateSourceName"
                (ngModelChange)="selectStaticTemplateSource($event)"
                placeholder="Search and copy a fetched template">
                <ng-template ng-option-tmp let-item="item">
                  <span class="iwb-template-option">
                    <b>{{ item.templateName }}</b>
                    <small>{{ item.language || item.type }}</small>
                  </span>
                </ng-template>
              </ng-select>
              <button
                type="button"
                class="iwb-template-refresh"
                [disabled]="loadingTemplates"
                title="Refresh templates"
                aria-label="Refresh templates"
                (click)="refreshTemplates()">
                <i
                  class="fa-solid fa-rotate-right"
                  [class.fa-spin]="loadingTemplates"></i>
              </button>
            </div>
          </div>
          <div class="dfield">
            <label>Title</label>
            <input
              class="inp"
              [ngModel]="draft().title"
              (ngModelChange)="setDraftValue('title', $event)"
              placeholder="Internal notification title" />
          </div>
          <div class="dfield" *ngIf="selectedChannel === 'email'">
            <label>Email subject</label>
            <input
              class="inp"
              [ngModel]="draft().subject"
              (ngModelChange)="setDraftValue('subject', $event)"
              placeholder="Subject shown to the recipient" />
          </div>
          <div class="dfield" *ngIf="selectedChannel === 'email'">
            <div
              class="iwb-notification-body-editor"
              [class.is-fullscreen]="emailBodyFullscreen">
              <div class="iwb-notification-body-head">
                <label>Email body</label>
                <div class="iwb-notification-body-head__actions">
                  <div
                    class="iwb-editor-mode-toggle"
                    role="tablist"
                    aria-label="Email body editor mode">
                    <button
                      type="button"
                      role="tab"
                      [class.is-active]="emailEditorMode === 'visual'"
                      [attr.aria-selected]="emailEditorMode === 'visual'"
                      (click)="setEmailEditorMode('visual')">
                      Visual
                    </button>
                    <button
                      type="button"
                      role="tab"
                      [class.is-active]="emailEditorMode === 'html'"
                      [attr.aria-selected]="emailEditorMode === 'html'"
                      (click)="setEmailEditorMode('html')">
                      HTML
                    </button>
                  </div>
                  <button
                    type="button"
                    class="iwb-notification-body-head__icon"
                    [attr.aria-pressed]="emailBodyFullscreen"
                    [title]="
                      emailBodyFullscreen
                        ? 'Exit fullscreen (Esc)'
                        : 'Edit in fullscreen'
                    "
                    (click)="toggleEmailBodyFullscreen()">
                    <i
                      class="fa-solid"
                      [class.fa-expand]="!emailBodyFullscreen"
                      [class.fa-compress]="emailBodyFullscreen"></i>
                  </button>
                </div>
              </div>
              <irembogov-visual-html-editor
                *ngIf="emailEditorMode === 'visual'"
                [html]="draft().emailBody || ''"
                [variables]="variables"
                [mostUsed]="mostUsedVariableLabels"
                [starterTemplates]="emailStarterTemplates"
                [fill]="emailBodyFullscreen"
                (htmlChange)="onVisualEmailBodyChange($event)"
                (supportedChange)="onVisualEmailSupportedChange($event)">
              </irembogov-visual-html-editor>
              <ng-container *ngIf="emailEditorMode === 'html'">
                <div class="iwb-notification-html-toolbar">
                  <irembogov-iwb-variable-token-select
                    [variables]="variables"
                    (tokenSelected)="insertVariable($event)">
                  </irembogov-iwb-variable-token-select>
                  <button
                    type="button"
                    class="iwb-variable-trigger iwb-notification-format-btn"
                    title="Reformat the HTML with consistent indentation"
                    (click)="formatEmailBody()">
                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                    <span>Format HTML</span>
                  </button>
                  <button
                    type="button"
                    class="iwb-variable-trigger iwb-notification-theme-btn"
                    [attr.aria-pressed]="isHtmlEditorDark"
                    [title]="
                      isHtmlEditorDark
                        ? 'Switch to light theme'
                        : 'Switch to dark theme'
                    "
                    (click)="toggleHtmlEditorTheme()">
                    <i
                      class="fa-solid"
                      [class.fa-sun]="isHtmlEditorDark"
                      [class.fa-moon]="!isHtmlEditorDark"></i>
                    <span>{{ isHtmlEditorDark ? 'Light' : 'Dark' }}</span>
                  </button>
                </div>
                <ngx-monaco-editor
                  class="iwb-statejson-editor iwb-notification-html-editor"
                  [options]="htmlEditorOptions"
                  [ngModel]="draft().emailBody"
                  [ngModelOptions]="{ standalone: true }"
                  (onInit)="onEmailBodyEditorInit($event)"
                  (ngModelChange)="
                    setDraftValue('emailBody', $event)
                  "></ngx-monaco-editor>
              </ng-container>
            </div>
          </div>
          <div class="dfield" *ngIf="selectedChannel === 'sms'">
            <label>SMS body</label>
            <irembogov-iwb-variable-token-select
              [variables]="variables"
              (tokenSelected)="insertVariable($event)">
            </irembogov-iwb-variable-token-select>
            <textarea
              class="inp iwb-notification-body iwb-notification-body--sms"
              [ngModel]="draft().smsBody"
              (ngModelChange)="setDraftValue('smsBody', $event)"
              placeholder="SMS text body"></textarea>
          </div>
        </ng-template>
      </section>

      <div
        class="iwb-template-replace-backdrop"
        *ngIf="pendingStaticTemplateName"
        (click)="cancelStaticTemplateSource()"></div>
      <div
        class="iwb-template-replace-dialog"
        *ngIf="pendingStaticTemplateName"
        role="dialog"
        aria-modal="true"
        aria-labelledby="iwb-template-replace-title">
        <div class="iwb-template-replace-copy">
          <b id="iwb-template-replace-title">Replace current content?</b>
          <p>Current content will be replaced by the selected template data.</p>
        </div>
        <div class="iwb-template-replace-actions">
          <button
            type="button"
            class="btn primary iwb-template-get-back"
            (click)="cancelStaticTemplateSource()">
            Get back
          </button>
          <button
            type="button"
            class="btn"
            (click)="confirmStaticTemplateSource()">
            Replace content
          </button>
        </div>
      </div>

      <section
        class="iwb-notification-preview iwb-notification-preview--bottom"
        aria-live="polite">
        <div class="iwb-preview-head">
          <div>
            <b>{{
              selectedChannel === 'email'
                ? 'Template validation'
                : 'SMS preview'
            }}</b>
            <small>{{ selectedLocale }}</small>
          </div>
          <span
            class="iwb-preview-badge"
            [class.api]="
              model.notificationType === 'NOTIFICATION_ENGINE_TEMPLATE'
            ">
            {{
              model.notificationType === 'NOTIFICATION_ENGINE_TEMPLATE'
                ? 'API'
                : 'Static'
            }}
          </span>
        </div>
        <div class="iwb-preview-title" *ngIf="previewTitle()">
          {{ previewTitle() }}
        </div>
        <div
          class="iwb-preview-errors"
          *ngIf="
            templateSyntaxErrors().length || templateVariableErrors().length
          ">
          <b>Template variable errors</b>
          <div *ngFor="let error of templateSyntaxErrors()">{{ error }}</div>
          <div *ngFor="let error of templateVariableErrors()">
            <strong>{{ error.variable }}</strong
            >: {{ error.message }}
          </div>
        </div>
        <!-- The visual/HTML editor above already renders the email, so there is
             no second rendered preview here — only variable validation. -->
        <p
          class="iwb-preview-ok"
          *ngIf="
            selectedChannel === 'email' &&
            !templateSyntaxErrors().length &&
            !templateVariableErrors().length
          ">
          No template issues found. The editor above shows the live rendering.
        </p>
        <ng-container *ngIf="selectedChannel === 'sms'">
          <div
            class="iwb-preview-values"
            *ngIf="missingPreviewVariables().length">
            <div class="iwb-preview-values-head">
              <b>Add sample values</b>
              <small
                >These values are used only for preview and are not saved in the
                workflow.</small
              >
            </div>
            <label
              class="iwb-preview-value-row"
              *ngFor="let variable of missingPreviewVariables()">
              <span>{{ previewLabelFor(variable) }}</span>
              <code>${{ '{' }}{{ variable }}{{ '}' }}</code>
              <input
                class="inp"
                [ngModel]="previewValueFor(variable)"
                (ngModelChange)="setPreviewValue(variable, $event)"
                placeholder="Preview value" />
            </label>
          </div>
          <div class="iwb-sms-phone-preview" aria-label="SMS phone preview">
            <div class="iwb-sms-phone">
              <div class="iwb-sms-screen">
                <div
                  class="iwb-sms-message"
                  *ngIf="previewBody(); else emptySmsPreview">
                  <pre>{{ previewBody() }}</pre>
                </div>
                <ng-template #emptySmsPreview>
                  <div class="iwb-sms-message muted">
                    <pre>No preview content yet.</pre>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </section>
    </div>
  </ng-container>

  <ng-template #jsonEditor>
    <ngx-monaco-editor
      class="iwb-statejson-editor iwb-notification-json"
      [options]="jsonEditorOptions"
      [(ngModel)]="jsonDraft"
      (ngModelChange)="jsonError = ''"></ngx-monaco-editor>
    <div class="dnone" style="color: #b42318" *ngIf="jsonError">
      {{ jsonError }}
    </div>
  </ng-template>
</div>
